/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOr = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.565 17.354c1.467 0 2.594-.45 3.382-1.348s1.183-2.177 1.183-3.836c0-1.65-.396-2.924-1.19-3.822S9.023 7 7.566 7s-2.583.45-3.376 1.348S3 10.52 3 12.17c0 1.66.394 2.938 1.183 3.836s1.915 1.348 3.382 1.348zm0-1.471c-1.88 0-2.819-1.238-2.819-3.713 0-1.22.239-2.14.715-2.764.477-.623 1.178-.935 2.104-.935s1.627.312 2.104.935c.476.624.715 1.545.715 2.764 0 2.475-.94 3.713-2.819 3.713zm7.989 1.292v-4.111l1.691.344 2.337 3.767h1.912l-2.64-4.098c.715-.192 1.262-.531 1.643-1.017s.57-1.095.57-1.829c0-.99-.307-1.746-.92-2.268s-1.509-.784-2.682-.784h-3.616v9.996zm0-5.239V8.568h1.279c.632 0 1.132.052 1.498.158s.628.281.784.529.234.582.234 1.004c0 .412-.078.74-.234.983s-.417.42-.784.53-.866.164-1.498.164z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOr as Or };
